import React, { useState } from "react";
// import { happy, sad, bird } from "../../constant/images";

import sad from "../../../assets/images/NewActivityImages/sad.jpg";
import happy from "../../../assets/images/NewActivityImages/happy.jpg";
import bird from "../../../assets/images/NewActivityImages/bird.jpg";


export default function BubbleSortQuiz() {
  const correct = {
    1: "b",
    2: "b",
    3: "a",
    4: "b",
    5: "a",
    6: "a",
    7: "a",
    8: "a",
    9: "a",
    10: "a",
  };

  const [current, setCurrent] = useState(1);
  const [results, setResults] = useState({});
  const [character, setCharacter] = useState(bird);

  const questions = [
    {
      question: "What is a searching algorithm?",
      options: [
        "A game we play in school",
        "A way for computers to find something in a list",
        "A type of school bag",
        "A color of crayon",
      ],
      answer: 1,
    },
    {
      question: "Why do computers need searching algorithms?",
      options: ["To play games", "To find things quickly", "To draw pictures", "To sleep"],
      answer: 1,
    },
    {
      question: "Where can we use searching algorithms?",
      options: ["Looking at the sky", "Watching TV", "Finding a word in a dictionary", "Eating lunch"],
      answer: 2,
    },
    {
      question: "What is Linear Search?",
      options: [
        "A dance move",
        "A magic trick",
        "Checking items one by one until the right one is found",
        "Jumping to the last item",
      ],
      answer: 2,
    },
    {
      question: "Which of these is a real-life example of Linear Search?",
      options: [
        "Guessing the answer without looking",
        "Looking for your pencil by checking each item in your bag",
        "Shouting the item’s name and hoping it appears",
        "Skipping everything and finding it first try",
      ],
      answer: 1,
    },
    {
      question: "In Linear Search, what do we do after finding the item?",
      options: ["Keep searching", "Take a nap", "Stop searching", "Eat snacks"],
      answer: 2,
    },
    {
      question: "What kind of lists is Linear Search best for?",
      options: [
        "Very long and sorted lists",
        "Tiny lists that are not sorted",
        "Only lists with numbers",
        "Colorful lists only",
      ],
      answer: 1,
    },
    {
      question: "What is one disadvantage of Linear Search?",
      options: ["It is fun", "It works too fast", "It checks every item, so it can be slow", "It forgets the item"],
      answer: 2,
    },
    {
      question: "What is one advantage of Linear Search?",
      options: [
        "It works only with toys",
        "It needs data to be sorted",
        "It’s simple and works on any kind of data",
        "It skips items randomly",
      ],
      answer: 2,
    },
    {
      question: "In the Toy Linear Flip Card Game, how do you find the toy?",
      options: ["Flip all cards at once", "Close your eyes and guess", "Flip cards one by one until you find the toy", "Ask someone else to do it"],
      answer: 2,
    },
  ];

  const handleAnswer = (qIndex, ans) => {
    if (ans === correct[qIndex + 1]) {
      setResults((prev) => ({ ...prev, [qIndex + 1]: "✅ Correct!" }));
      setCharacter(happy);
      setTimeout(() => {
        setCurrent((prev) => prev + 1);
        setCharacter(bird);
      }, 1200);
    } else {
      setResults((prev) => ({ ...prev, [qIndex + 1]: "❌ Try again!" }));
      setCharacter(sad);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Comic Neue', cursive",
        background: "linear-gradient(135deg,rgb(255, 255, 255), #ffffff)",
        textAlign: "center",
        color: "#333",
        padding: "30px",
        overflowX: "hidden",
        position: "relative",
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          color: "#ff6f61",
          textShadow: "2px 2px #fff",
          fontSize: "2.5em",
        }}
      >
        Bubble Sort Adventure Quiz!
      </h1>
      <p>Answer one question at a time to move forward in the Bubble Sort journey!</p>

      <img
        src={character}
        alt="Cartoon"
        style={{
          position: "fixed",
          bottom: "10px",
          left: "10px",
          width: "120px",
          transition: "all 0.5s ease",
        }}
      />

      {questions.map((q, i) =>
        current === i + 1 ? (
          <div
            key={i}
            style={{
              background: "linear-gradient(135deg,rgb(126, 153, 230),rgb(142, 181, 231))",
              margin: "20px auto",
              padding: "25px",
              borderRadius: "20px",
              width: "80%",
              boxShadow: "0 6px 25px rgba(0,0,0,0.15)",
            }}
          >
            <h3>
              {i + 1}️⃣ {q.question}
            </h3>
            {q.options.map((opt, idx) => (
              <button
                key={idx}
                style={{
                  background: "linear-gradient(45deg, #f6d365, #fda085)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "12px",
                  padding: "12px 25px",
                  cursor: "pointer",
                  margin: "8px",
                  fontSize: "1em",
                }}
                onClick={() => handleAnswer(i, String.fromCharCode(97 + idx))}
              >
                {String.fromCharCode(65 + idx)}. {opt}
              </button>
            ))}
            <div
              style={{
                fontWeight: "bold",
                marginTop: "15px",
                fontSize: "1.2em",
                color: results[i + 1]?.includes("✅") ? "green" : "red",
              }}
            >
              {results[i + 1]}
            </div>
          </div>
        ) : null
      )}

      {current > questions.length && (
        <h2 style={{ color: "#00897b" }}>
          🎉 Amazing! You finished the Bubble Sort Quiz!
        </h2>
      )}
    </div>
  );
}
